import React, { memo } from "react";

const EmptyState = memo(
  ({
    icon: Icon,
    title,
    description,
    className = "py-4 text-center text-gray-500 bg-gray-50 rounded border-2 border-dashed",
  }) => (
    <div className={className}>
      {Icon && <Icon className="mx-auto mb-2 w-8 h-8 text-gray-400" />}
      {title && <p className="font-medium">{title}</p>}
      {description && <p className="mt-1 text-sm">{description}</p>}
    </div>
  )
);

export default EmptyState;
